import { Fragment } from 'react'
import { Link as ScrollLink } from 'react-scroll'
import Sticky from 'react-stickynode'
import { chakra } from '@chakra-ui/react'

import { MainMenu, linkStyle } from './Sidebar.style'
import { useActiveRoute, Link } from '@/lib/Link'

const ChakraScrollLink = chakra(ScrollLink)

const scrollProps = {
  smooth: true,
  activeClass: 'active',
  spy: true,
  duration: 300,
  offset: -80,
}

type Props = {
  menus: TermsItem[]
  bottomBoundary: string
}

const Sidebar = (props: Props): React.ReactElement => {
  const { menus = [], bottomBoundary } = props

  const getIsActiveRoute = useActiveRoute()

  const renderMenu = () => {
    return menus.map((menuItem, idx) => {
      const isActive = getIsActiveRoute(menuItem.checkActive)

      return (
        <Fragment key={idx}>
          <MainMenu active={isActive}>
            <Link route={menuItem.linkTo}>
              <a>{menuItem.title}</a>
            </Link>
          </MainMenu>

          {isActive && menuItem.subMenus && (
            <ul
              css={{
                display: 'grid',
                gridAutoRows: 'minmax(24px, max-content)',
                gap: '18px',
                alignItems: 'center',
                marginBottom: '60px',
              }}
            >
              {menuItem.subMenus.map((navi, idx) => (
                <li
                  key={idx}
                  css={{
                    paddingLeft: navi.isSub ? '40px' : '20px',
                    display: 'flex',
                  }}
                >
                  <ChakraScrollLink
                    to={navi.scrollTo}
                    sx={linkStyle}
                    {...scrollProps}
                  >
                    {navi.title}
                  </ChakraScrollLink>
                </li>
              ))}
            </ul>
          )}
        </Fragment>
      )
    })
  }

  return (
    <aside
      css={{
        display: 'grid',
        alignContent: 'start',
        gap: '16px',
        top: '224px',
        padding: '32px 18px 0 0',
      }}
    >
      <Sticky top={111} bottomBoundary={bottomBoundary}>
        {renderMenu()}
      </Sticky>
    </aside>
  )
}

export default Sidebar
